var _rect, _circle, _path, _rect2, _rect3, _circle2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccountInfoV(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 2,
    width: 26,
    height: 33.5636,
    rx: 4,
    fill: "#53E3AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10,
    r: 2.5,
    fill: "#D0FFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.5C15.5147 13.5 13.5 15.3775 13.5 17.6935C13.5 17.8302 13.507 17.9654 13.5207 18.0987C13.545 18.3342 13.7527 18.5 13.9894 18.5H22.0106C22.2473 18.5 22.455 18.3342 22.4793 18.0987C22.493 17.9654 22.5 17.8302 22.5 17.6935C22.5 15.3775 20.4853 13.5 18 13.5Z",
    fill: "#D0FFED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.49268,
    y: 22.9835,
    width: 17.3727,
    height: 2.6,
    rx: 1.3,
    fill: "#D0FFED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.49268,
    y: 27.776,
    width: 13.4788,
    height: 2.6,
    rx: 1.3,
    fill: "#D0FFED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.7998,
    cy: 32.5,
    r: 6.5,
    fill: "#1290FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5498 32.4999H34.0498",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7998 29.25L30.7998 35.75",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountInfoV);
export default __webpack_public_path__ + "static/media/icon_account_info_v.d446446f.svg";
export { ForwardRef as ReactComponent };